import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'form', 'count', 'action']

  // The server re-sends the selection count after every tick (set_session); the bulk
  // menus open only while it isn't 0
  countTargetConnected(element) {
    const none = element.dataset.count === '0'
    this.actionTargets.forEach((button) => { button.disabled = none })
  }

  toggleAll(event) {
    const selectAllCheckbox = event.target
    const isChecked = selectAllCheckbox.checked

    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = isChecked
    })
  }

}
